/**
 * Header Drawer Outside Click Handler
 * Adds functionality to close the drawer when clicking outside of it
 * This extends the existing header-drawer functionality without modifying global.js
 */

document.addEventListener('DOMContentLoaded', () => {
  const headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer) return;

  const mainDetails = headerDrawer.querySelector('details');
  if (!mainDetails) return;

  const handleOutsideClick = (event) => {
    // ドロワーが開いていない場合は何もしない
    if (!mainDetails.hasAttribute('open')) return;

    // モーダルが開いている場合はドロワーを閉じない（モーダルの挙動に任せる）
    const modalOpen = document.querySelector('details-modal details[open], fac-details-modal details[open]');
    if (modalOpen) return;

    // クリックがドロワー内部、またはハンバーガーメニューボタンの場合は何もしない
    const summary = mainDetails.querySelector('summary');
    if (headerDrawer.contains(event.target) || summary?.contains(event.target)) {
      return;
    }

    // ドロワーの外側をクリックした場合、サマリーをクリックしてクローズ
    summary?.click();
  };

  // details要素の開閉状態を監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'open') {
        if (mainDetails.hasAttribute('open')) {
          // ドロワーが開いた時、少し遅延してイベントリスナーを追加
          // (即座に追加すると、開くためのクリックイベントを拾ってしまう)
          setTimeout(() => {
            document.addEventListener('click', handleOutsideClick);
          }, 100);
        } else {
          // ドロワーが閉じた時、イベントリスナーを削除
          document.removeEventListener('click', handleOutsideClick);
        }
      }
    });
  });

  // MutationObserverでdetails要素のopen属性の変化を監視
  observer.observe(mainDetails, { attributes: true });
});
